import React from 'react';
import { connect } from 'react-redux';
import agent from '../agent';
import Slider from 'react-slick';
import GoogleMapReact from 'google-map-react';
import './GroupView.css';
import Collapsible from 'react-collapsible';
import groupData from '../data/groups.json';
import groups from '../data/groups.json';

const mapToProps = state => ({
  properties: state.home.properties,
  currentImg: 0
});

const mapDispatchToProps = dispatch => ({
  onLoad: payload =>
    dispatch({ type: 'PAGE_LOADED', payload}),
  onNext : nextImg =>
  	dispatch({ type: 'UPDATE_FIELD', key: 'currentImg', nextImg})
});

class GroupView extends React.Component {
	constructor(){
		super();
		window.scrollTo(0, 0);
		this.Next = (currentImg) =>{
			this.props.onNext(currentImg + 1);
			console.log(this.props);
		};
	}



	render (){
		var settings = {
	    	arrows: true,
	    	autoplay: false,
	    }
	    var maps = {
	    	center: {lat: 59.95, lng: 30.33},
		    zoom: 11
	    }
		var groupId = this.props.location.search.split('=')[1];
		var groupNum;
		var currentImg = this.props.currentImg ? this.props.currentImg : 0;
		console.log(groups.length);
		if (groups){
			for (var i = 0; i < groups.length; i++) {
				console.log(groups[i]._id );
				console.log(groupId );

				if(groups[i]._id == groupId){
					groupNum = i;
				}
			};
			console.log(groupNum);
			var group = groups[groupNum];
			console.log(group);
			var images = group.images.map((image, index) => 
				<div key={index}>
				<a target="_blank" href={image}>
	                <img className="groupImg center-block img-responsive" alt="Carousel Bootstrap First" src={image}></img>
				</a>
				</div>
			);
			console.log(group.schools);
			var schools = group.schools.map((school, index) =>
				<div key={index} className="container">
					<div className="row">
						<h4>{school.name}</h4>
					</div>
					<div className="row">
						<a target="_blank" href={school.website}>{school.website}</a>
					</div>
					<div className="row">
						<a target="_blank" href={"tel:" + school.tel}>{school.tel}</a>
					</div>	
				</div>

			);
			var trashDays = group.utility.trash.map((day, index) =>
				<li key={index}>{day}</li>
			);
			if(group.utility.recycle){
				var recycle = group.utility.recycle.map((day, index) =>
					<li key={index}>{day}</li>
				);
			}
			console.log(images);
		}
		return (
			<div>
				<div className="container" style={{backgroundColor: '#efefef'}}>
					<div className="row">
					<div className= "col-xs-1 col-md-2 col-lg-2"></div>
					<div className= "col-xs-10 col-md-8 col-lg-8">
					<h1 className="text-center">{group.name}</h1>
					<hr className="groupHeader"/>
					<Slider {...settings}>
						{images}
					</Slider>
					<h3 className="text-center">{group.address}</h3>
					<p className="text-center">{group.description}</p>
					<div className="row">
							<Collapsible open="true" trigger="Schools">
								{schools}
							</Collapsible>
							<Collapsible open="true" trigger="Rules and Regulations">
								<p>Click <a target="_blank" href={group.rules}>here</a> to view the Rules and Regulations for {group.name} </p>
							</Collapsible>
							<Collapsible open="true" trigger="General Information">
								<div className="row">
									<div className="col-xs-11">
										<h4>Emergency Contact Information</h4>
									</div>
								</div>
								<div className="row">
									<div className="col-xs-11">
										<ul>
											<li>In case of a life threatning emergency call <b>911</b></li>
											<li><b>Police Department</b>: <a target="_blank" href={"tel:"+group.emergency.police}>{group.emergency.police}</a></li>
											<li><b>Fire Department</b>: <a target="_blank" href={"tel:"+group.emergency.fire}>{group.emergency.fire}</a></li>
										</ul>
									</div>
								</div>
								<div className="row">
									<div className="col-xs-11">
										<h4>Utility Contact Information</h4>
									</div>
								</div>
								<div className="row">
									<div className="col-xs-11">
										<ul>
											<li><b>Water and Sewage</b>: {group.utility.water.name} <a target="_blank" href={"tel:"+ group.utility.water.tel}>{group.utility.water.tel}</a></li>
											<li><b>Electricity</b>: {group.utility.electricity.name} <a target="_blank" href={"tel:" + group.utility.electricity.tel}>{group.utility.electricity.tel}</a></li>
										</ul>
									</div>
								</div>
								<div className="row">
									<div className="col-xs-11">
										<h4>Trash Days</h4>
									</div>
								</div>
								<div className="row">
									<div className="col-xs-11">
										<ul>
											{trashDays}
										</ul>
									</div>
								</div>
								{ recycle &&
									<div>
										<div className="row">
											<div className="col-xs-11">
												<h4>Recycle Days</h4>
											</div>
										</div>
										<div className="row">
											<div className="col-xs-11">
												<ul>
													{recycle}
												</ul>
											</div>
										</div>
									</div>
								}
							</Collapsible>
						
					</div>
					<div className= "col-xs-1 col-md-2 col-lg-2"></div>
					</div>
					</div>
					<br/>
					<br/>
					<br/>
					<br/>

					<footer/>
					
		        </div>
			</div>
		)
	}
}

export default connect(mapToProps, mapDispatchToProps)(GroupView);



// WEBPACK FOOTER //
// ./src/components/GroupView.js